import { render } from "./ScoreDisplay.vue?vue&type=template&id=36cbb546&scoped=true"
import script from "./ScoreDisplay.vue?vue&type=script&lang=js"
export * from "./ScoreDisplay.vue?vue&type=script&lang=js"

import "./ScoreDisplay.vue?vue&type=style&index=0&id=36cbb546&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\stall\\Documents\\Projects\\Web Apps\\Small Projects\\gmscoreboard2021-primevue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cbb546"]])

export default __exports__